import { Box, Grid2, Typography } from '@mui/material'
import React, { useEffect,useRef, useState } from 'react'
import SearchBar from '../../shared/components/SearchBar'
import CustomDivider from '../../shared/utils/CustomDivider'
import CourseCard from '../../shared/components/CourseCard'
import { useDialog } from '../../shared/hook/useDialog'
import MainDialogBox from '../../shared/components/Dialog/DialogMainBox'
import { LightButton } from '../../shared/utils/CustomButton'
import FilterListIcon from '@mui/icons-material/FilterList';
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import { AutoCompleteField } from '../../shared/components/FormFields/AutoCompleteField'
import { DateFormField } from '../../shared/components/FormFields/DataFormField'
import DialogFooter from '../../shared/components/Dialog/DialogFooter'
import { Page_Padding } from '../../shared/constants'
import { useCourseCategory, useCourseFilter, useCourses, useLocationCourse } from '../../assets/api/useGetApi'
import { SkeletonCom } from '../../shared/utils/SkeletonCom'
import useResponsive from '../../shared/utils/Responsive'
import { getGridSize } from '../../shared/formatter'
// const tabsData = [
//     {
//         label: "Aparmtment", component: <>
//             <Field
//                 name="apartment1"
//                 component={CheckboxFormField}
//                 label="Forum apartments"
//                 isRequired={true}
//             />
//             <Field
//                 name="apartment2"
//                 component={CheckboxFormField}
//                 label="Lulu apartments Majestic "
//                 isRequired={true}
//             />
//         </>
//     },
//     {
//         label: "Schools", component: <>
//             <Field
//                 name="school1"
//                 component={CheckboxFormField}
//                 label="Forum apartments"
//                 isRequired={true}
//             />
//             <Field
//                 name="scholl2"
//                 component={CheckboxFormField}
//                 label="Lulu apartments Majestic "
//                 isRequired={true}
//             />
//         </>
//     }
// ];

const Courses = () => {

    const { open, handleClickOpen, handleClose } = useDialog();
    const { data: courses, isLoading, isFetchingNextPage, fetchNextPage, hasNextPage } = useCourses();
    const allCourses = courses?.pages.flatMap(page => page.data) || [];
    const observerRef = useRef(null);

    useEffect(() => {
        if (!observerRef.current) return;

        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting && hasNextPage && !isFetchingNextPage) {
                    fetchNextPage();
                }
            },
            { threshold: 1 }
        );

        observer.observe(observerRef.current);

        return () => observer.disconnect();
    }, [fetchNextPage, hasNextPage, isFetchingNextPage, observerRef]);
    const { data: locationList, isLocationLoading } = useLocationCourse();
    const isSmallScreen = useResponsive("sm")
    const locationOptions = locationList?.data?.map((location) => ({
        id: location?.id,
        label: location?.name,
        value: location?.name,
    })) || []

    const { data: courseCategory, isLoading: isCategoryLoading } = useCourseCategory();

    const CategoryOptions = courseCategory?.data?.map((category) => ({
        id: category?.id,
        label: category?.name,
        value: category?.name,
    })) || []
    const [filters, setFilters] = useState({}); // Store filters
    const { data: filterCourse, isLoading: filterIsLoading } = useCourseFilter(filters);
    const initialValues = {
        start_date: "",
        end_date: "",
        category_id: "",
        location_id: "",
    };
    const validationSchema = Yup.object().shape({
    });


    const handleSubmit = async (values, { resetForm }) => {
        const filteredValues = Object.fromEntries(
            Object.entries(values).filter(([_, v]) => v !== "" && v !== null && v !== undefined)
        );
        setFilters(filteredValues);

        handleClose();
        resetForm()
    };

    return (
        <Box className="body event_course" px={Page_Padding}>
            <SearchBar />
            <CustomDivider orientation="horizontal" size={isSmallScreen ? "20px" : undefined} />
            <Box textAlign={"end"}>
                <LightButton onClick={handleClickOpen} text={"Filter"} icon={<FilterListIcon sx={{ color: "#000000", fontSize: "24px" }} />} />
            </Box>
            <CustomDivider orientation="horizontal" size={isSmallScreen ? "20px" : undefined} />
            <Grid2 container spacing={5} sx={{ display: 'flex', justifyContent: "center" }}>
                {(isLoading && filterIsLoading) ? (
                    [...Array(9)].map((_, index) => (
                        <Grid2 children size={{ xs: 12, sm: 6, md: 4 }} key={index}>
                            <SkeletonCom />
                        </Grid2>
                    ))
                ) : filterCourse?.data?.length > 0 ? (
                    filterCourse?.data.map((item, index) => (
                        <Grid2 children size={{ xs: 12, sm: 6, md: getGridSize(filterCourse?.data?.length) }} key={index}
                            display={"flex"} alignItems={"stretch"}
                        >
                            <CourseCard item={item} />
                        </Grid2>
                    ))
                ) : filterCourse?.data?.length === 0 ? (
                    <Box textAlign="center" width="100%">
                        <Typography variant='h6'>Course not found.</Typography>
                    </Box>
                ) : (
                    allCourses.map((item, index) => (
                        <Grid2 children size={{ xs: 12, sm: 6, md: getGridSize(allCourses?.length) }} key={index}
                            display={"flex"} alignItems={"stretch"}
                        >
                            <CourseCard item={item} />
                        </Grid2>
                    ))
                )}
            </Grid2>
            {isFetchingNextPage && (
                <Grid2 container spacing={5} sx={{ display: "flex", justifyContent: "center" }}>
                    {[...Array(3)].map((_, index) => (
                        <Grid2 children size={{ xs: 12, sm: 6, md: 4 }} key={index}>
                            <SkeletonCom />
                        </Grid2>
                    ))}
                </Grid2>
            )}

            <div ref={observerRef} style={{ height: "20px", marginBottom: "10px" }} />
            <MainDialogBox open={open} handleClose={handleClose} width={"30%"} heading={"Filter"}>
                <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
                    {({ values }) => (
                        <Form>
                            <Grid2 container spacing={"30px"}>
                                <Grid2 children size={{ xs: 12, sm: 6 }}>
                                    <Field
                                        name="start_date"
                                        component={DateFormField}
                                        label="From Date"
                                        maxDate={values.end_date || undefined}
                                    />
                                </Grid2>
                                <Grid2 children size={{ xs: 12, sm: 6 }}>
                                    <Field
                                        name="end_date"
                                        component={DateFormField}
                                        minDate={values.start_date || undefined}
                                        label="To Date"
                                    />
                                </Grid2>
                                <Grid2 children size={12}>
                                    <Field
                                        name="category_id"
                                        component={AutoCompleteField}
                                        options={CategoryOptions}
                                        label="Course Category"
                                        isLoading={isCategoryLoading}
                                    />
                                </Grid2>
                                {/* <Grid2 children size={12}>
                                    <Field
                                        name="price"
                                        component={AutoCompleteField}
                                        options={cityOptions}
                                        label="Price"
                                    />
                                </Grid2> */}
                                {/* <Grid2 children size={12}>
                                    <Field
                                        name="Age"
                                        component={CustomSlider}
                                        label="Age"
                                        initialValue={1}
                                        finalValue={20}
                                    />
                                </Grid2> */}
                                <Grid2 children size={12}>
                                    <Field
                                        name="location_id"
                                        component={AutoCompleteField}
                                        options={locationOptions}
                                        label="Location"
                                        isLoading={isLocationLoading}

                                    />
                                </Grid2>
                                {/* <Grid2 children size={12}>
                                    <TabsComponent tabs={tabsData} value={value} onChange={handleChange} />
                                    {tabsData.map((tab, index) => (
                                        <TabPanel key={index} value={value} index={index}>
                                            {tab.component}
                                        </TabPanel>
                                    ))}
                                </Grid2> */}

                                <Grid2 children size={12}>
                                    <DialogFooter handleClose={handleClose} buttonName={"Filter"} />
                                </Grid2>
                            </Grid2>
                        </Form>
                    )}
                </Formik>
            </MainDialogBox>
        </Box>
    )
}

export default Courses